import { useMutation, useQueryClient } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';

interface IFormValues {
    landArea: number;
    landAreaUnitTypeId: number;
    floorAreaRatio: number;
    proFormaId: number;
}

interface IUpdateVariables {
    dealId: number;
    proFormaId: number;
}

const deleteProForma = async ({ dealId, proFormaId }: IUpdateVariables): Promise<IFormValues> => {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.ORGANIZATION_PRO_FORMA(dealId, proFormaId)}`);
    return response.data;
};

const useHardDeleteProForma = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteProForma,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getProFormas'] });
        },
        onError: error => {
            console.error('Error deleting lot:', error);
        },
    });
};

export default useHardDeleteProForma;
